import { createSlice } from '@reduxjs/toolkit';
import courseApi from 'api/courseApi';
import unitsApi from 'api/unitsApi';
import unitCourseApi from 'api/unitCourseApi';
import { logout } from '../auth/index';
import { SELECTED_CENTRES } from 'helpers/storage';

const initialState = {
  course: undefined,
  listUnits: undefined,
  typeUpdate: 0,
  error: undefined,
  homeFilter: undefined,
  isUpdate: undefined,
};

const courseSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    setCourse: (state, action) => {
      state.course = action.payload;
    },
    setCourseError: (state, action) => {
      state.error = action.payload;
    },
    setListUnits: (state, action) => {
      state.listUnits = action.payload;
    },
    setTypeUpdate: (state, action) => {
      state.typeUpdate = action.payload;
    },
    setHomeFilter: (state, action) => {
      state.homeFilter = action.payload;
    },
    setIsUpdate: (state, action) => {
      state.isUpdate = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const getCourse = (state) => state.courses.course;
export const getCourseError = (state) => state.courses.error;
export const getListUnits = (state) => state.courses.listUnits;
export const getTypeUpdate = (state) => state.courses.typeUpdate;
export const getHomeFilter = (state) => state.courses.homeFilter;
export const getIsUpdate = (state) => state.courses.isUpdate;
export const {
  setCourse,
  setListUnits,
  setCourseError,
  setTypeUpdate,
  setHomeFilter,
  setIsUpdate,
} = courseSlice.actions;

export const getCourseAsync = (id) => async (dispatch) => {
  let vl = typeof window !== 'undefined' ? SELECTED_CENTRES.get() : null;
  const selectedCentre =
    typeof vl !== 'undefined' && vl !== null && vl !== ''
      ? JSON.parse(vl)
      : undefined;
  if (id) {
    const course = await courseApi.getById(
      id,
      selectedCentre?._id
        ? {
            courseCentre: selectedCentre?._id,
            reviewContent: selectedCentre?.reviewContent,
          }
        : null,
    );
    return dispatch(setCourse(course));
  }
};

export const adminGetListUnitsAsync = (params) => async (dispatch) => {
  const units = await unitsApi.get(params);
  return dispatch(setListUnits(units?.data));
};

export const learnerGetListUnitsAsync = (params) => async (dispatch) => {
  const units = await unitCourseApi.getUnits(params);
  return dispatch(setListUnits(units?.data || []));
};

export default courseSlice.reducer;
